var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter"},[_c('button',{staticClass:"cs-btn",class:_vm.activeButton ? 'cs-btn__outline-custom--active' : 'cs-btn__outline-custom',attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('changeActive', _vm.tagIndex), _vm.changeActive()}}},[_vm._v(" "+_vm._s(_vm.tag.tag)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }